import type { MouseEvent, Ref } from "react";
import { useCallback } from "react";
import type { IStatusProps } from "./types";
import "./index.css";
import { clsx } from "clsx";
import { Text } from "../Text";

export const Status = ({
  color = "neutral",
  size = "md",
  text,
  onClick,
  className,
  ref,
}: IStatusProps) => {
  const rootClass: string = clsx(
    "nuco-status",
    `nuco-color-${color}`,
    `nuco-status--${size}`,
    onClick && "nuco-status--clickable",
    className,
  );

  const handleClick = useCallback(
    (e: MouseEvent): void => {
      e.stopPropagation();

      if (onClick) {
        onClick(e);
      }
    },
    [onClick],
  );

  const content = (
    <>
      <span className="nuco-status__circle" aria-hidden="true" />
      <Text size={size} className="nuco-status__text">
        {text}
      </Text>
    </>
  );

  // A clickable status is a real button, so it is focusable and keyboard operable.
  if (onClick) {
    return (
      <button
        // Safe: a button is an HTMLElement; RefObject is only invariant in TS.
        ref={ref as Ref<HTMLButtonElement>}
        type="button"
        className={rootClass}
        onClick={handleClick}
      >
        {content}
      </button>
    );
  }

  return (
    <div ref={ref as Ref<HTMLDivElement>} className={rootClass}>
      {content}
    </div>
  );
};
